import { render, staticRenderFns } from "./MainArticleList.vue?vue&type=template&id=3303353e&scoped=true&"
import script from "./MainArticleList.vue?vue&type=script&lang=js&"
export * from "./MainArticleList.vue?vue&type=script&lang=js&"
import style0 from "./MainArticleList.vue?vue&type=style&index=0&id=3303353e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3303353e",
  null
  
)

export default component.exports